'use strict';

angular.module('app.revertNetwork', [])	
	.controller('revertNetworkCtrl', ['$scope', '$modal', '$modalInstance', 'revertNetworkService',
		function ($scope, $modal, $modalInstance, revertNetworkService) {
    
            $scope.confirmRevert = function () {
                revertNetworkService.revertNetwork($scope.network_id, true)
                	.then(function(response) {
                		$scope.modalInstance.close(function () {
        	                $log.info('Close Modal now');
        	            })

        	            location.reload(true);
                	}, function(response) {
                		var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = response.message;
                	})
            }

            $scope.closeModal = function() {
                $modalInstance.close();
            }
}])